import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=0799bacd&scoped=true"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"
import style0 from "./Theme.vue?vue&type=style&index=0&id=0799bacd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799bacd",
  null
  
)

export default component.exports